import React, { useEffect, useState } from 'react'
import ReservationSidebar from '../../Commun/ReservationSidebar'
import ReservationHeader from '../../Commun/ReservationHeader'
import { useProperty } from '../../../PropertyContext';
import { useDispatch, useSelector } from 'react-redux';
import { deleteVoucherOffer, fetchVoucherOffers } from '../../../Redux/Slices/voucherOffersSlice';
import { AddVoucherOffer } from './AddVoucherOffer';
import swal from "sweetalert";
import { EditVoucherOffer } from './EditVoucherOffer';
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";

export const VoucherOffers = () => {
    const { selectedProperty } = useProperty();
    const [selectedOffer, setSelectedOffer] = useState(null);
    const dispatch = useDispatch();

    const { offersList } = useSelector((state) => state.voucherOffers);

    useEffect(() => {

        dispatch(fetchVoucherOffers(selectedProperty.PropertyID));

    }, [dispatch, selectedProperty]);

    const handleDelete = async (id) => {

        const willDelete = await swal({
            title: "Are you sure?",
            icon: "warning",
            buttons: true,
            dangerMode: true,
        });

        if (willDelete) {

            try {
                const resultAction = await dispatch(deleteVoucherOffer(id));

                if (deleteVoucherOffer.fulfilled.match(resultAction)) {
                    swal("Deleted!", "Voucher Offer deleted successfully.", "success");
                } else {
                    swal("Error!", "Something went wrong!", "error");
                }

            } catch (error) {
                swal("Error!", "Failed to delete!", "error");
            }
        }
    };
    return (
        <>
            <div className="wrapper">
                <ReservationSidebar />
                <div className="main-panel">
                    <ReservationHeader />
                    <div className="container">
                        <div className="page-inner">

                            <div className="row">
                                <div className="col-md-12">


                                    <div className="card">
                                        <div className="card-header">
                                            <div className='d-flex justify-content-between align-items-center'>
                                                <h4 className="card-title MB-0">VOUCHER OFFERS</h4>
                                                <button type="button" className="btn btn-primary btn-sm waves-effect waves-light mt-1" data-bs-toggle="modal" data-bs-target="#Add-Voucer-Offer">Add </button>
                                            </div>

                                        </div>
                                        {/* <div className="card-body">
                                            <div className="table-responsive">
                                                <div className="text-end mb-2">

                                                </div>
                                                <table
                                                    className="display table table-striped table-hover basic-datatables"
                                                >
                                                    <thead>
                                                        <tr>
                                                            <th style={{ width: "15rem" }}>Title</th>
                                                            <th style={{ width: "50rem" }}>Description</th>
                                                            <th>Action</th>
                                                        </tr>
                                                    </thead>

                                                    <tbody>
                                                        {offersList && offersList.length > 0 ? (
                                                            offersList
                                                                .filter(item => item.IsActive)
                                                                .map((item) => (
                                                                    <tr key={item.ID}>
                                                                        <td>{item.Title}</td>
                                                                        <td>{item.Description}</td>
                                                                        <td>
                                                                            <button type="button" className='btn' data-bs-toggle="modal" data-bs-target="#Edit-Voucer-Offer" onClick={() => setSelectedOffer(item)}><i className='fas fa-edit'></i></button>
                                                                            <button className="btn text-danger" onClick={() => handleDelete(item.ID)}><i className='fas fa-trash'></i></button>
                                                                        </td>
                                                                    </tr>
                                                                ))
                                                        ) : (
                                                            <tr>
                                                                <td colSpan="3" className="text-center">
                                                                    No Data Found
                                                                </td>
                                                            </tr>
                                                        )}
                                                    </tbody>


                                                </table>
                                            </div>
                                        </div> */}

                                        <div className="card-body">
                                            <DataTable
                                                value={offersList?.filter(item => item.IsActive)}
                                                paginator
                                                rows={10}
                                                rowsPerPageOptions={[5, 10, 25]}
                                                stripedRows
                                                showGridlines
                                                responsiveLayout="scroll"
                                                emptyMessage="No Data Found"
                                                filterDisplay="menu"
                                            >

                                                {/* Title */}
                                                <Column
                                                    field="Title"
                                                    header="Title"
                                                    sortable
                                                    filter
                                                    filterPlaceholder="Search Title"
                                                    style={{ width: "15rem" }}
                                                />

                                                {/* Description */}
                                                <Column
                                                    field="Description"
                                                    header="Description"
                                                    sortable
                                                    filter
                                                    filterPlaceholder="Search Description"
                                                    style={{ width: "50rem" }}
                                                />

                                                {/* Action Column */}
                                                <Column
                                                    header="Action"
                                                    headerClassName="action-header-center"
                                                    body={(rowData) => (
                                                        <div className="d-flex gap-2">
                                                            <button
                                                                type="button"
                                                                className="btn"
                                                                data-bs-toggle="modal"
                                                                data-bs-target="#Edit-Voucer-Offer"
                                                                onClick={() => setSelectedOffer(rowData)}
                                                            >
                                                                <i className="fas fa-edit"></i>
                                                            </button>

                                                            <button
                                                                className="btn text-danger"
                                                                onClick={() => handleDelete(rowData.ID)}
                                                            >
                                                                <i className="fas fa-trash"></i>
                                                            </button>
                                                        </div>
                                                    )}
                                                    style={{ width: "8rem" }}
                                                />

                                            </DataTable>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </div>


            {/* Voucher Offer modal content */}
            <div id="Add-Voucer-Offer" className="modal fade" tabIndex={-1} role="dialog" aria-hidden="true" >
                <div className="modal-dialog">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h4 className="modal-title">Add Offers</h4>
                            <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close" />
                        </div>
                        <div className="modal-body">
                            <AddVoucherOffer />
                        </div>
                    </div>
                </div>
            </div>
            {/* /.modal */}


            {/* Edit Voucher Offer modal content */}
            <div id="Edit-Voucer-Offer" className="modal fade" tabIndex={-1} role="dialog" aria-hidden="true" >
                <div className="modal-dialog">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h4 className="modal-title">Add Offers</h4>
                            <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close" />
                        </div>
                        <div className="modal-body">
                            <EditVoucherOffer offerData={selectedOffer} />
                        </div>
                    </div>
                </div>
            </div>
            {/* /.modal */}
        </>
    )
}
